import React from 'react';

const Content = ({ children }) => (
  <main className="w-2/3 flex flex-col h-screen overflow-hidden bg-white">
    {children}
    <div className="h-[128px]"></div>
  </main>
);

export default Content;